<template>
  <div id="HistoricoSolicitud_div" class="w-100 px-0 py-0">
    <div id="TituloHistoricoSolicitud_div">
      <h5 style="margin-bottom: 0px;">REPORTES</h5>
      <h6 style="margin-top: 0px;">Reporte de Solicitudes de documentos por Estatus</h6>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
        <div class="area" style="margin-top: 0px">
          <div>
            <h6 style="margin-top: 0px;">Búsqueda</h6>
          </div>
          <div class="row">
            <div class="form-group col-2">
              <label>Fecha Inicial:</label>
              <input class="form-control" type="date" v-model="Busqueda.fechaInicial">
            </div>
            <div class="form-group col-2">
              <label>Fecha Final:</label>
              <input class="form-control" type="date" v-model="Busqueda.fechaFinal">
            </div>
            <div class="form-group col-4" id="Busqueda_div">
              <label>Área:</label>
              <CAreas v-on:valorParaElPadre="cambioDeArea"
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      :idDelInput="'filtroDeBusqueda_Area'"
                      :parametros="parametros_Area"
                      :valorDefinido="parametros_Area.areaId"
                      :key="parametros_Area.areaId">
              </CAreas>
            </div>

            <div class="form-group col-1" style="margin-top: 26px;">
              <button class="btn btn-sm btn-dark" @click='ObtenerHistorial()'>Obtener Historial</button>
            </div>
          </div>
          <div id="ZonaImpresion" v-if="this.Totales > 0">
            <div >
              <h6 style="margin-top: 0px;">Resultados del periodo de {{this.AreaResultado.Fecha1}} hasta {{this.AreaResultado.Fecha2}}, en {{this.AreaResultado.Nombre}} </h6>
              <h6>Total de Solicitudes :  {{this.Totales}}</h6>
            </div>
            <div id="Volumen_table" class="table-responsive">
              <table class="table table-striped table-light table-hover table-sm">
                <thead class="thead-dark">
                  <tr>
                    <th>Terminadas</th>
                    <th>Canceladas</th>
                    <th>En Prestamo</th>
                    <th>En Devolución</th>
                    <th>En Tramite</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="detalle in SolicitudesDocumentos">
                    <td>{{detalle.Terminada}}</td>
                    <td>{{detalle.Cancelada}}</td>
                    <td>{{detalle.Prestamo}}</td>
                    <td>{{detalle.Devolucion}}</td>
                    <td>{{detalle.Solicitud}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div id="graficasSolicitudes_div">
              <Grafica :options="chartOptions"></Grafica>
            </div>
          </div>
        </div>
        <div class="area" v-if="Totales>0">
          <div class="text-right">
              <button class="btn btn-sm btn-dark" @click='ImprimirReporte()' >Imprimir Reporte</button>      
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import highcharts from '@/../static/js/highchart'
import LogoPJE from '@/../src/assets/logo-pj-transparente-negro.png'

export default {
  components:{
    CAreas: catalogos.ArchivoJudicial.C001Areas,
    Grafica : highcharts
  },
    data(){
        return{
            enumeraciones,
            Busqueda: {
              fechaInicial: moment().add(-1, 'months').format('YYYY-MM-DD'),
              fechaFinal: moment().format('YYYY-MM-DD')
            },
            SolicitudesDocumentos: [],
            Porcentajes: [],
            parametros_Area: {
              areaId: -1,
              nombre: "",
              conMaterias: true
            },
            Totales: 0,
            TotalEstadistica: Array,
            AreaResultado: {
              AreaId: 0,
              Nombre: "",
              Fecha1: "",
              Fecha2: ""
            },
            chartOptions: {
              chart: {
                  plotBackgroundColor: null,
                  backgroundColor: "#DADADA",
                  plotBorderWidth: null,
                  plotShadow: false,
                  type: 'pie'
                },
                title: {
                  text: 'Solicitudes '
                },
                tooltip: {
                  pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                credits: {
                  enabled: false
                },
              lang: {
                viewFullscreen: "Ver en pantalla completa",
                printChart: "Imprimir gráfica",
                downloadJPEG: "Descargar imagen JPEG",
                downloadPDF: "Descargar documento PDF",
                downloadPNG: "Descargar imagen PNG",
                downloadSVG: "Descargar imagen SVG"
              },
              series: [{
                name: 'Brands',
                colorByPoint: true,
                data: [
                    {name: 'Solicitudes Terminadas',
                    y: 25.0
                    }, {
                    name: 'Solicitudes en Prestamo',
                    y: 25.0
                    }, {
                    name: 'Solicitudes en Devolución',
                    y: 25.0
                    }, {
                    name: 'Solicitudes en Tramite',
                    y: 25.0
                    }, {
                    name: 'Solicitudes Canceladas',
                    y: 25.0
                  }
                  ]
                  }]
            }
        }
    },
    methods :{
        cambioDeArea(datos){
            this.parametros_Area.areaId = parseInt(datos[0].target.value);
            this.parametros_Area.nombre = datos[0].target.selectedOptions[0].text;
        },
        ObtenerHistorial(){
              this.AreaResultado.AreaId = this.parametros_Area.areaId;
              this.AreaResultado.Nombre = this.parametros_Area.nombre;
              this.AreaResultado.Fecha1 = moment(this.Busqueda.fechaInicial).format('DD-MM-YYYY')
              this.AreaResultado.Fecha2 = moment(this.Busqueda.fechaFinal).format('DD-MM-YYYY')
              this.SolicitudesDocumentos =[];
              this.Porcentajes = [];
              if(this.ValidarDatos()) {
              var peticion= {
                        "FechaInicial": this.Busqueda.fechaInicial,
                        "FechaFinal": this.Busqueda.fechaFinal,
                        "AreaId": this.parametros_Area.areaId
                  };
              
              comun.SeEstaCargandoInformacion(true);
              axios.post(api.conexion + api.ArchivoJudicial.HistoricosDeSolicitudes, peticion,
              comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                        if(respuesta.data.SiHayError)
                        {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        }
                        else
                        {
                            this.TotalEstadistica = respuesta.data.Totales;
                            this.Totales = this.TotalEstadistica[0];
                            var solicitudes = {
                              "Solicitud": this.TotalEstadistica[1],
                              "Prestamo" : this.TotalEstadistica[2],
                              "Devolucion" : this.TotalEstadistica[3],
                              "Terminada" : this.TotalEstadistica[4],
                              "Cancelada" : this.TotalEstadistica[5]
                            }
                            this.SolicitudesDocumentos.push(solicitudes);


                            this.Porcentajes.push ({name: 'Solicitudes Terminadas', y: (this.TotalEstadistica[4]/this.Totales) * 100});
                            this.Porcentajes.push ({name: 'Solicitudes en Prestamo', y: (this.TotalEstadistica[2]/this.Totales) * 100});
                            this.Porcentajes.push ({name: 'Solicitudes en Devolución', y: (this.TotalEstadistica[3]/this.Totales) * 100});
                            this.Porcentajes.push ({name: 'Solicitudes en Tramite', y: (this.TotalEstadistica[1]/this.Totales) * 100});
                            this.Porcentajes.push ({name: 'Solicitudes Canceladas', y: (this.TotalEstadistica[5]/this.Totales) * 100});
                           
                            this.chartOptions.series[0].data = this.Porcentajes;

                            
                            if(this.Totales == 0)
                            {
                              comun.mensajeDeAlerta("Búsqueda sin resultado", null, null);
                            }
                            comun.SeEstaCargandoInformacion(false);
                        }
                        comun.SeEstaCargandoInformacion(false);
                        })
                        .catch(excepcion => {
                            console.log(excepcion);
                            console.log("fallo por parametros");
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false);
                        });
              }

        },
        ValidarDatos(){
            if(this.Busqueda.fechaInicial == "" || this.Busqueda.fechaInicial == null)
            { comun.mensajeDeAlerta("Indicar una fecha valida de inicio de rango de consulta.", null, null);
                    return false;
            };
            if(this.Busqueda.fechaFinal == "" || this.Busqueda.fechaFinal == null)
            { comun.mensajeDeAlerta("Indicar una fecha valida de fin de rango de consulta.", null, null);
                    return false;
            };
            if(this.Busqueda.fechaInicial > this.Busqueda.fechaFinal)
            { comun.mensajeDeAlerta("Fecha Inicial no puede ser mayor a fecha final.", null, null);
                    return false;
            };
            if(this.parametros_Area.areaId == -1)
            {
              comun.mensajeDeAlerta("Seleccione una Área para obtener historial.", null, null);
              return false;
            }
            return true;
        },
        ImprimirReporte(){
          var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">SOLICITUDES POR ESTATUS</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('</div>');

            printWin.document.write('<div class="area">');
            
            var areaImpresion = document.getElementById('ZonaImpresion').innerHTML;
            printWin.document.write(areaImpresion);
            
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Historicos/HistoricoSolicitudes.vue